import { Alert, SolvTheme, Spinner, Stack, Text } from '@solvhealth/jigsaw-v1';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSrpSearch } from '~/components/CareTeam/hooks/useSrpSearch';
import { useOnMembershipEntrypointClicked } from '~/components/Membership/utils';
import ResponsiveSlideInDialog from '~/components/SolvDesignSystem/Dialog/ResponsiveSlideInDialog';
import {
  PREMIUM_IN_PERSON_BOOKING_FLOW,
  PREMIUM_IN_PERSON_START_NEW_UC_SEARCH,
  PREMIUM_IN_PERSON_START_SOLV_NOW_VISIT,
  SOLV_NOW_ENTRYPOINT_IN_PERSON_SLOTS,
} from '~/core/analytics/events';
import { useNearbyPremiumLocations } from '~/core/dapi/premiumInPerson';
import useToggleRuntimeModal from '~/hooks/runtime/useToggleRuntimeModal';
import { PremiumLocationCard } from './PremiumLocationCard';

export const PREMIUM_IN_PERSON_SLOT_SELECTOR = 'premiumInPersonSlotSelector';

export const PremiumInPersonSlotSelector = () => {
  const [open, toggle] = useToggleRuntimeModal(PREMIUM_IN_PERSON_SLOT_SELECTOR);
  const { data, isLoading } = useNearbyPremiumLocations();

  const { t } = useTranslation(['membership']);

  const pushToUrgentCareSearch = useSrpSearch('uc');

  const { onClick: pushToSolvNowVisit } = useOnMembershipEntrypointClicked(
    SOLV_NOW_ENTRYPOINT_IN_PERSON_SLOTS
  );

  return (
    <ResponsiveSlideInDialog onClose={toggle} open={open}>
      <Stack maxWidth={SolvTheme.breakpoints.sm} space={4}>
        <Stack space={2}>
          <Text variant="h3">{t('membership:premiumInPersonLocationSelector.title')}</Text>

          {isLoading && <Spinner />}

          {data &&
            data.map((loc) => (
              <PremiumLocationCard key={loc.id} location={loc} onSelect={toggle} />
            ))}
        </Stack>

        <Alert
          actions={[
            <Alert.Action
              event={PREMIUM_IN_PERSON_BOOKING_FLOW}
              key="start-visit"
              meta={{ action: PREMIUM_IN_PERSON_START_SOLV_NOW_VISIT }}
              onClick={() => pushToSolvNowVisit()}
            >
              {t('membership:premiumInPersonLocationSelector.alert.startVisit')}
            </Alert.Action>,
            <Alert.Action
              event={PREMIUM_IN_PERSON_BOOKING_FLOW}
              key="search"
              meta={{ action: PREMIUM_IN_PERSON_START_NEW_UC_SEARCH }}
              onClick={pushToUrgentCareSearch}
            >
              {t('membership:premiumInPersonLocationSelector.alert.search')}
            </Alert.Action>,
          ]}
          icon={null}
          show
          title={t('membership:premiumInPersonLocationSelector.alert.title')}
          tone="info"
        >
          {t('membership:premiumInPersonLocationSelector.alert.subtitle')}
        </Alert>
      </Stack>
    </ResponsiveSlideInDialog>
  );
};
